import * as i0 from "@angular/core";
var UtilsService = /** @class */ (function () {
    function UtilsService() {
    }
    UtilsService.prototype.extractUrlParams = function () {
        var paramsTab = location.search.slice(1).split('&');
        var params = {};
        for (var i = 0; i < paramsTab.length; i += 1) {
            var p = paramsTab[i].split('=');
            params[p[0]] = p[1];
        }
        return params;
    };
    UtilsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(); }, token: UtilsService, providedIn: "root" });
    return UtilsService;
}());
export { UtilsService };
